import React from 'react';
import Navbar from '../components/Navbar';
import FeaturesHero from '../components/FeaturesHero';
import FeaturesCarousel from '../components/FeaturesCarousel';
import BuiltForRecruiting from '../components/BuiltForRecruiting';
import FeaturesBenefits from '../components/FeaturesBenefits';
import FAQ from '../components/FAQ';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';
import SeamlessBackground from '../components/SeamlessBackground';

const Features: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#022334] text-white font-sans antialiased relative">
            {/* Seamless CSS Background */}
            <SeamlessBackground />

            {/* Content */}
            <div className="relative z-10">
                <Navbar />
                <main className="relative">
                    {/* FeaturesHero Section */}
                    <FeaturesHero />

                    {/* FeaturesCarousel Section */}
                    <FadeInSection delay={0.2}>
                        <FeaturesCarousel />
                    </FadeInSection>

                    {/* BuiltForRecruiting Section */}
                    <FadeInSection delay={0.2}>
                        <BuiltForRecruiting />
                    </FadeInSection>

                    {/* FeaturesBenefits Section */}
                    <FadeInSection delay={0.2}>
                        <FeaturesBenefits />
                    </FadeInSection>

                    {/* FAQ Section */}
                    <FadeInSection delay={0.2}>
                        <FAQ />
                    </FadeInSection>

                    {/* CallToAction Section */}
                    <FadeInSection delay={0.2}>
                        <CallToAction />
                    </FadeInSection>
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default Features;
